export default "__VITE_ASSET__7250e711__"